import React, { FC } from 'react';

const CargoBikeIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className ?? ''}
    xmlns="http://www.w3.org/2000/svg"
    width="4.6mm"
    height="8.1mm"
    viewBox="0 0 13 23"
  >
    <rect width="13" height="23" fill="#fff" fillOpacity="0" opacity="0" />
    <path
      d="M12.3,12.8a2.6,2.6,0,0,0-1.4-2.1l.3-.7H12V9.1H9.6V10H10v.5H9.8a2.2,2.2,0,0,0-2.2,1.9H7.3v-3H8.6v-1H7.3V6.6L.7,8.6v4.8h.9a1.9,1.9,0,0,0,2,1.9,1.9,1.9,0,0,0,1.9-1.9H7.6A2.4,2.4,0,0,0,10,15.3h.1a2.3,2.3,0,0,0,2.2-2.4ZM3.6,14.2a1,1,0,0,1-.9-.8H4.4C4.3,13.8,4,14.2,3.6,14.2Zm6-2.6-.3.8H8.6A1.4,1.4,0,0,1,9.6,11.6Zm.4,2.7a1.4,1.4,0,0,1-1.4-.9h1.7v-1h0l.3-.8a1.5,1.5,0,0,1,.8,1.3A1.4,1.4,0,0,1,10,14.3Z"
      transform="translate(0 0)"
      fill="#666"
    />
  </svg>
);

export default CargoBikeIcon;
